<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  data-test="create-feed-advice"
  (backAction)="back()"
>
  <ng-container actions>
    <mat-select
      *ngIf="mode === 'view'"
      [hideSingleSelectionIndicator]="true"
      class="flex__child--auto spacing--margin-right text--small headerSelector"
      data-test="printsetting-selector"
      (selectionChange)="setPrintSetting($event)"
      [value]="printSetting"
    >
      <mat-option [value]="'pocketsize'">{{
        'sows-feed-advice.report-setting.pocketsize' | translate
      }}</mat-option>
      <mat-option [value]="'fullsize'">{{
        'sows-feed-advice.report-setting.fullsize' | translate
      }}</mat-option>
    </mat-select>
    <button
      *ngIf="mode === 'view'"
      mat-flat-button
      color="accent"
      data-test="feed-advice__report-button"
      (click)="printFeedAdvice()"
    >
      <mat-icon>print</mat-icon>
      {{ getButtonText('print') }}
    </button>
    <button
      *ngIf="mode === 'create' || mode === 'edit'"
      type="submit"
      mat-flat-button
      color="accent"
      (click)="save()"
      data-test="feed-advice__save-button"
    >
      <mat-icon>save</mat-icon>
      {{ getButtonText('save') }}
    </button>
  </ng-container>

  <agr-print-page
    class="print-only"
    [footerText]="pageTitle$ | async"
    [customizedLogoSrc]="
      (location$ | async)?.country === 'NL' ? '/assets/images/thinkpig_50.png' : null
    "
  >
    <ng-container *ngIf="printSetting === 'fullsize'">
      <app-sows-feed-advice-report
        [advice]="advice"
        [parityCategory]="parityCategory"
        [inputSystem]="inputSystem"
      ></app-sows-feed-advice-report>
    </ng-container>
  </agr-print-page>

  <div
    class="spacing--margin-horizontal"
    *ngIf="(isLoading$ | async) === false && !!tableConfig && printSetting === 'fullsize'"
  >
    <ng-container *ngIf="mode === 'create' || mode === 'edit'">
      <button
        *ngIf="!isReferenceFeedAdvice"
        mat-button
        class="button--text float-right"
        (click)="openPriceSettings()"
        data-test="feed-advice__pricesettings-button"
      >
        <mat-icon class="material-icons-outlined">settings</mat-icon>
        {{ 'price-settings.title' | translate }}
      </button>
      <h3>{{ 'create-feed-advice.properties.name' | translate }}</h3>
      <mat-form-field class="flex__child--auto feedadvice-name">
        <input
          matInput
          required
          placeholder="{{ 'create-feed-advice.properties.name' | translate }}"
          data-test="create-feed-advice__feedadvice-name"
          [(ngModel)]="advice.name"
          #name="ngModel"
        />
      </mat-form-field>
      <div *ngIf="name.invalid && (name.dirty || name.touched)" class="validation-error">
        <div *ngIf="name.errors?.['required']">
          {{ 'feed-advice-detail.validation-error.description.feedadvice-name' | translate }}
        </div>
      </div>

      <app-feed-advice-settings
        [isReferenceFeedAdvice]="isReferenceFeedAdvice"
        [locations]="advice.locationIds"
        [properties]="feedAdviceProperties"
        (settingsChanged)="changeFeedAdviceProperties($event)"
      ></app-feed-advice-settings>

      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--bold label">
            {{ 'feed-advice-properties.input-system.label' | translate }}
          </span>
        </div>
        <div class="flex--column spacing--padding-right">
          <mat-radio-group (change)="setParityAndInputSystem()" [(ngModel)]="inputSystem">
            <mat-radio-button
              data-test="feed-advice-properties_input-system-energy-radiobutton"
              class="text--small"
              color="primary"
              [value]="'EnergyDay'"
            >
              {{ 'feed-advice-properties.input-system.energy' | translate }}
            </mat-radio-button>
            <mat-radio-button
              data-test="feed-advice-properties_input-system-feed-radiobutton"
              class="text--small"
              color="primary"
              [value]="'KgDay'"
            >
              {{ 'feed-advice-properties.input-system.feed' | translate }}
            </mat-radio-button>
            <mat-radio-button
              data-test="feed-advice-properties_input-system-dosator-radiobutton"
              class="text--small"
              color="primary"
              [value]="'Dosator'"
            >
              {{ 'feed-advice-properties.input-system.dosator' | translate }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="spacing--margin-top flex--row flex--nowrap">
        <ng-container *ngIf="advice.feedAdviceType === 'SowsBreedToFarrow'">
          <div class="flex--column">
            <span class="text--small text--bold label">
              {{ 'feed-advice-properties.input-parity-system.label' | translate }}
            </span>
          </div>
          <div class="flex--column spacing--padding-right">
            <mat-radio-group (change)="setParitySystem()" [(ngModel)]="useParitySystem">
              <mat-radio-button
                data-test="feed-advice-properties_input-parity-system-yes-radiobutton"
                class="text--small"
                color="primary"
                [value]="true"
              >
                {{ 'feed-advice-properties.input-parity-system.parity' | translate }}
              </mat-radio-button>
              <mat-radio-button
                data-test="feed-advice-properties_input-parity-system-no-radiobutton"
                class="text--small"
                color="primary"
                [value]="false"
              >
                {{ 'feed-advice-properties.input-parity-system.alternate' | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </ng-container>
        <div class="flex--column">
          <span class="text--small text--bold label">
            {{
              useParitySystem
                ? ('feed-advice-properties.parity-category.label' | translate)
                : ('feed-advice-properties.parity-category.alternative.label' | translate)
            }}
          </span>
        </div>
        <div class="flex--column spacing--padding-right">
          <mat-radio-group (change)="setParityAndInputSystem()" [(ngModel)]="parityCategory">
            <mat-radio-button
              data-test="feed-advice-properties_parity-category-OneToTwo-radiobutton"
              class="text--small"
              color="primary"
              [value]="'OneToTwo'"
            >
              {{
                useParitySystem
                  ? ('feed-advice-properties.parity-category.OneToTwo' | translate)
                  : ('feed-advice-properties.parity-category.alternative.OneToTwo' | translate)
              }}
            </mat-radio-button>
            <mat-radio-button
              data-test="feed-advice-properties_parity-category-TwoToFour-radiobutton"
              class="text--small"
              color="primary"
              [value]="'TwoToFour'"
            >
              {{
                useParitySystem
                  ? ('feed-advice-properties.parity-category.TwoToFour' | translate)
                  : ('feed-advice-properties.parity-category.alternative.TwoToFour' | translate)
              }}
            </mat-radio-button>
            <mat-radio-button
              data-test="feed-advice-properties_parity-category-OneToFour-radiobutton"
              [class]="useParitySystem ? 'text--small hidden' : 'text--small'"
              color="primary"
              [value]="'OneToFour'"
            >
              {{ 'feed-advice-properties.parity-category.alternative.OneToFour' | translate }}
            </mat-radio-button>
            <mat-radio-button
              data-test="feed-advice-properties_parity-category-OneToFive-radiobutton"
              class="text--small"
              color="primary"
              [value]="'OneToFive'"
            >
              {{
                useParitySystem
                  ? ('feed-advice-properties.parity-category.OneToFive' | translate)
                  : ('feed-advice-properties.parity-category.alternative.OneToFive' | translate)
              }}
            </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="spacing--margin-top flex--row flex--nowrap" *ngIf="!useParitySystem">
        <ng-container [formGroup]="formGroupParityAlternative">
          <div class="flex--column spacing--padding-right">
            <input
              matInput
              class="formfield-outline"
              [value]="advice.parityAlternative2"
              data-test="feed-advice-properties__parity-category-input-parityalternative2"
              formControlName="parityAlternative2"
              [class.error-border]="
                parityAlternative2FormControl.touched && parityAlternative2FormControl.errors
              "
            />
            <span
              class="validation-error"
              *ngIf="parityAlternative2FormControl.touched && parityAlternative2FormControl.errors"
            >
              {{ 'feed-advice-properties.parity-category.alternative.error' | translate }}
            </span>
          </div>
          <div class="flex--column spacing--padding-right">
            <input
              matInput
              class="formfield-outline"
              [value]="advice.parityAlternative3"
              data-test="feed-advice-properties__parity-category-input-parityalternative3"
              formControlName="parityAlternative3"
              [class.error-border]="
                parityAlternative3FormControl.touched && parityAlternative3FormControl.errors
              "
            />
            <span
              class="validation-error"
              *ngIf="parityAlternative3FormControl.touched && parityAlternative3FormControl.errors"
            >
              {{ 'feed-advice-properties.parity-category.alternative.error' | translate }}
            </span>
          </div>

          <div
            class="flex--column spacing--padding-right"
            *ngIf="
              parityCategory === 'TwoToFour' ||
              parityCategory === 'OneToFour' ||
              parityCategory === 'OneToFive'
            "
          >
            <input
              matInput
              class="formfield-outline"
              [value]="advice.parityAlternative4"
              data-test="feed-advice-properties__parity-category-input-parityalternative4"
              formControlName="parityAlternative4"
              [class.error-border]="
                parityAlternative4FormControl.touched && parityAlternative4FormControl.errors
              "
            />
            <span
              class="validation-error"
              *ngIf="parityAlternative4FormControl.touched && parityAlternative4FormControl.errors"
            >
              {{ 'feed-advice-properties.parity-category.alternative.error' | translate }}
            </span>
          </div>

          <div
            class="flex--column spacing--padding-right"
            *ngIf="parityCategory === 'OneToFour' || parityCategory === 'OneToFive'"
          >
            <input
              matInput
              class="formfield-outline"
              [value]="advice.parityAlternative5"
              data-test="feed-advice-properties__parity-category-input-parityalternative5"
              formControlName="parityAlternative5"
              [class.error-border]="
                parityAlternative5FormControl.touched && parityAlternative5FormControl.errors
              "
            />
            <span
              class="validation-error"
              *ngIf="parityAlternative5FormControl.touched && parityAlternative5FormControl.errors"
            >
              {{ 'feed-advice-properties.parity-category.alternative.error' | translate }}
            </span>
          </div>

          <div class="flex--column spacing--padding-right" *ngIf="parityCategory === 'OneToFive'">
            <input
              matInput
              class="formfield-outline"
              [value]="advice.parityAlternative6"
              data-test="feed-advice-properties__parity-category-input-parityalternative6"
              formControlName="parityAlternative6"
              [class.error-border]="
                parityAlternative6FormControl.touched && parityAlternative6FormControl.errors
              "
            />
            <span
              class="validation-error"
              *ngIf="parityAlternative6FormControl.touched && parityAlternative6FormControl.errors"
            >
              {{ 'feed-advice-properties.parity-category.alternative.error' | translate }}
            </span>
          </div>
        </ng-container>
      </div>

      <div class="spacing--margin-top flex--row flex--nowrap">
        <ng-container *ngIf="showDosatorColumns">
          <div class="flex--column">
            <span class="text--small text--bold label">
              {{ 'settings.dosator-settings' | translate }}
            </span>
          </div>

          <div class="flex--column spacing--padding-right">
            <mat-select
              #dosatorSettingSelector
              [hideSingleSelectionIndicator]="true"
              class="formfield-outline"
              data-test="feed-advice-properties__dosator-settings"
              (ngModelChange)="changeDosatorSettingSelection($event.id)"
              [(ngModel)]="selectedDosatorSetting"
            >
              <mat-option
                *ngFor="let dosatorSetting of dosatorSettings$ | async"
                [value]="dosatorSetting"
              >
                {{ dosatorSetting.name }}
              </mat-option>
            </mat-select>
          </div>
        </ng-container>

        <ng-container *ngIf="showDosatorColumns">
          <div class="flex--column spacing--padding-right">
            <span class="text--small italic label">
              {{ 'sows-feed-advice.dosator-input-note' | translate }}
            </span>
          </div>
        </ng-container>
      </div>

      <h3>{{ 'create-feed-advice.scheme.remarks' | translate }}</h3>
      <div class="remarks-panel">
        <textarea
          class="text--small remarks-field"
          label="remarks"
          rows="3"
          placeholder="{{ 'create-feed-advice.scheme.remarks-placeholder' | translate }}"
          data-test="feed-advice__remarks"
          [(ngModel)]="advice.description"
        ></textarea>
      </div>

      <div class="flex--row flex--nowrap spacing--margin-vertical">
        <div class="flex--column spacing--padding-right">
          <mat-slide-toggle
            color="primary"
            [hideIcon]="true"
            [(ngModel)]="showLysineColumns"
            (change)="setParityAndInputSystem()"
            data-test="feed-advice__show-lysine-switch"
          >
            <span class="text--small">
              {{ 'feed-advice-properties.show-lysine-switch' | translate }}
            </span>
          </mat-slide-toggle>
        </div>
        <div class="flex--column spacing--padding-right">
          <mat-slide-toggle
            color="primary"
            [hideIcon]="true"
            [(ngModel)]="showEnergyColumns"
            (change)="setParityAndInputSystem()"
            data-test="feed-advice__show-energy-switch"
          >
            <span class="text--small">
              {{ 'feed-advice-properties.show-energy-switch' | translate }}
            </span>
          </mat-slide-toggle>
        </div>
        <div class="flex--column">
          <mat-slide-toggle
            color="primary"
            [hideIcon]="true"
            [(ngModel)]="showDosatorColumns"
            (change)="setParityAndInputSystem()"
            data-test="feed-advice__show-dosator-switch"
          >
            <span class="text--small">
              {{ 'feed-advice-properties.show-dosator-switch' | translate }}
            </span>
          </mat-slide-toggle>
        </div>
      </div>
    </ng-container>

    <!-- READONLY PROPERTIES -->
    <div class="screen-only spacing--margin-bottom readonly-properties" *ngIf="mode === 'view'">
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'create-feed-advice.properties.name' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__name">
            {{ advice.name }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feedAdviceType.label' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ 'select-feed-advice-type.' + advice.type | translate }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.date' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__date">
            {{ advice.updated | agrDate: 'dd-MM-yyyy' }}
          </span>
        </div>
        <div class="flex--column" *ngIf="!isReferenceFeedAdvice">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.advisor' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__advisor-name">
            {{ advice.advisorName }}
          </span>
        </div>
        <div class="flex--column" *ngIf="isReferenceFeedAdvice"></div>
      </div>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div
          *ngIf="advice.feedAdviceType === 'SowsBreedToFarrow' && advice?.bodyCondition"
          class="flex--column"
        >
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.bodycondition' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__bodycondition">
            {{ 'feed-advice-properties.body-condition.' + advice.bodyCondition | translate }}
          </span>
        </div>
        <div *ngIf="advice.feedAdviceType === 'SowsFarrowToWean'" class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.transition-day' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__transition-day">
            {{ advice.transitionDay }}
          </span>
        </div>
        <div *ngIf="advice.feedAdviceType === 'SowsFarrowToWean'" class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.piglets-per-farrowing-category' | translate }}
          </span>
          <span
            class="text--small text--bold label"
            data-test="feed-advice__piglets-per-farrowing-category"
          >
            {{ advice.pigletsPerFarrowingCategory }}
          </span>
        </div>
        <div class="flex--column" *ngIf="advice.geneticLine">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.geneticline' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__geneticline">
            {{ advice.geneticLine }}
          </span>
        </div>
        <div class="flex--column" *ngIf="!advice.geneticLine"></div>
        <div class="flex--column" *ngIf="advice.useParitySystem">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.paritycategory' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__paritycategory">
            {{ 'feed-advice-properties.parity-category.' + parityCategory | translate }}
          </span>
        </div>
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.inputsystem' | translate }}
          </span>
          <span class="text--small text--bold label" data-test="feed-advice__inputsystem">
            {{ 'feed-advice-properties.input-system.' + inputSystem | translate }}
          </span>
        </div>
      </div>
      <div class="spacing--margin-top flex--row flex--nowrap">
        <div class="flex--column">
          <span class="text--small text--gray label">
            {{ 'feed-advice-detail.remarks' | translate }}
          </span>
          <span class="text--small text--bold label">
            {{ advice.description }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div
    class="spacing--margin-horizontal spacing--margin-top"
    *ngIf="(isLoading$ | async) === false && !!tableConfig"
  >
    <ng-container *ngIf="mode === 'create' || mode === 'edit'">
      <!-- ADD / REMOVE ROW TO TOP -->
      <div class="mat-button-row spacing--margin-top" *ngIf="mode === 'create' || mode === 'edit'">
        <button
          mat-stroked-button
          color="primary"
          style="font-size: 12px"
          data-test="feed-advice__add-top-button"
          (click)="changeNumberOfTableRows('add-top')"
        >
          <mat-icon>add</mat-icon>{{ 'sows-feed-advice.buttons.add-top' | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          style="font-size: 12px"
          data-test="feed-advice__remove-top-button"
          [disabled]="tableConfig.dataSource.data.length <= 1"
          (click)="changeNumberOfTableRows('remove-top')"
        >
          <mat-icon>remove</mat-icon>{{ 'sows-feed-advice.buttons.remove-top' | translate }}
        </button>
      </div>
      <!-- FEED ADVICE TABLE-->
      <agr-table
        [config]="tableConfig"
        [emptyTitle]="'sows-feed-advice-detail.no-feedadvice-lines.title' | translate"
        [emptyDescription]="'sows-feed-advice-detail.no-feedadvice-lines.description' | translate"
        emptyImage="assets/images/pigs_001.jpg"
        data-test="feed-advice__table"
        [enableStepArrows]="false"
      ></agr-table>

      <ng-template #productNameTemplate let-row="row">
        <mat-select
          [hideSingleSelectionIndicator]="true"
          class="flex__child--auto spacing--margin-right text--small"
          panelClass="mat-select-product-panel"
          [value]="getProduct(row, products$ | async)"
          [compareWith]="areProductsEqual"
          placeholder="<product>"
          (selectionChange)="selectProduct($event, row)"
          (closed)="onProductOpenedChange()"
          data-test="product-column"
        >
          <mat-form-field style="width: 100%">
            <input
              matInput
              #filterProductsInput
              (keyup)="onFilterProductsKeyUp(filterProductsInput.value)"
              [(ngModel)]="filterProductsValue"
            />
          </mat-form-field>
          <mat-option *ngFor="let product of filteredProducts" [value]="product">
            {{ product.code }} - {{ product.name }}
          </mat-option>
        </mat-select>
      </ng-template>

      <!-- ADD / REMOVE ROW TO TOP -->
      <div class="mat-button-row spacing--margin-top" *ngIf="mode === 'create' || mode === 'edit'">
        <button
          mat-stroked-button
          color="primary"
          style="font-size: 12px"
          data-test="feed-advice__add-bottom-button"
          (click)="changeNumberOfTableRows('add-bottom')"
        >
          <mat-icon>add</mat-icon>{{ 'sows-feed-advice.buttons.add-bottom' | translate }}
        </button>
        <button
          mat-stroked-button
          color="primary"
          style="font-size: 12px"
          data-test="feed-advice__remove-bottom-button"
          [disabled]="tableConfig.dataSource.data.length <= 1"
          (click)="changeNumberOfTableRows('remove-bottom')"
        >
          <mat-icon>remove</mat-icon>{{ 'sows-feed-advice.buttons.remove-bottom' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          style="float: right"
          data-test="feed-advice__calculate-columns"
          (click)="updateFeedadviceRows()"
        >
          <mat-icon>autorenew</mat-icon>{{ getCalculateButtonLabel() }}
        </button>
      </div>
    </ng-container>

    <!-- READONLY POCKETSIZE DOSATOR TABLE-->
    <ng-container *ngIf="mode === 'view' && printSetting === 'pocketsize'">
      <div class="spacing--margin-bottom readonly-properties flex--column">
        <span class="text--small text--gray label">
          {{ 'create-feed-advice.properties.name' | translate }}
        </span>
        <span class="text--small text--bold label" data-test="feed-advice__name">
          {{ advice.name }}
        </span>
      </div>

      <h3>{{ 'sows-feed-advice.table.label-pocketsize' | translate }}</h3>
      <table data-test="pocketsize-table" class="pocketsize-table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th [attr.colspan]="advice?.sowFeedAdviceLines[0].parityRegistrations.length">
              {{ 'sows-feed-advice.table.dosator' | translate }}
              {{ useParitySystem ? ('parity' | translate) : '' }}
            </th>
          </tr>
          <tr>
            <th class="align-left">{{ 'sows-feed-advice.table.dayFrom' | translate }}</th>
            <th class="align-left">{{ 'sows-feed-advice.table.dayTo' | translate }}</th>
            <ng-container
              *ngFor="
                let parityRegistration of advice?.sowFeedAdviceLines[0].parityRegistrations;
                let i = index
              "
            >
              <th class="align-left">
                {{
                  useParitySystem
                    ? getParityHeaderText(parityRegistration.parity)
                    : i === 0
                      ? advice.parityAlternative2
                      : i === 1
                        ? advice.parityAlternative3
                        : i === 2
                          ? advice.parityAlternative4
                          : i === 3
                            ? advice.parityAlternative5
                            : i === 4
                              ? advice.parityAlternative6
                              : ''
                }}
              </th>
            </ng-container>
            <th class="align-left">
              {{ 'sows-feed-advice.table.feedingTimesPerDay1' | translate }}
              {{ 'sows-feed-advice.table.feedingTimesPerDay2' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of advice?.sowFeedAdviceLines">
            <td>{{ line.dayFrom }}</td>
            <td>{{ line.dayTo }}</td>
            <ng-container *ngFor="let parityRegistration of line.parityRegistrations">
              <td class="medium-column">
                {{ parityRegistration.dosatorPosition | agrNumber: '1.1-1' }}
              </td>
            </ng-container>
            <td>{{ line.feedingTimesPerDay }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <!-- READONLY FEED ADVICE TABLE-->
    <ng-container *ngIf="mode === 'view' && printSetting === 'fullsize'">
      <h3>{{ 'sows-feed-advice.table.label' | translate }}</h3>
      <table data-test="feed-advice-table" class="fullsize-table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th
              *ngIf="showEnergyColumns"
              [attr.colspan]="advice?.sowFeedAdviceLines[0].parityRegistrations.length"
              class="screen-only"
            >
              {{ 'sows-feed-advice.table.energy' | translate }}
              ({{ getCorrectEwTranslation(energySystem) }}/d)
              {{ useParitySystem ? ('parity' | translate) : '' }}
            </th>
            <th></th>
            <th [attr.colspan]="advice?.sowFeedAdviceLines[0].parityRegistrations.length">
              {{ 'sows-feed-advice.table.feed' | translate }} (kg/d)
              {{ useParitySystem ? ('parity' | translate) : '' }}
            </th>
            <th class="align-left" *ngIf="advice.showDosatorColumns">
              {{ 'sows-feed-advice.table.feedingTimesPerDay1' | translate }}
            </th>
            <th
              [attr.colspan]="advice?.sowFeedAdviceLines[0].parityRegistrations.length"
              *ngIf="advice.showDosatorColumns"
            >
              {{ 'sows-feed-advice.table.dosator' | translate }}
              {{ useParitySystem ? ('parity' | translate) : '' }}
            </th>
          </tr>
          <tr>
            <th class="align-left">{{ 'sows-feed-advice.table.dayFrom' | translate }}</th>
            <th class="align-left">{{ 'sows-feed-advice.table.dayTo' | translate }}</th>
            <ng-container
              *ngFor="
                let parityRegistration of advice?.sowFeedAdviceLines[0].parityRegistrations;
                let i = index
              "
            >
              <th class="align-left screen-only" *ngIf="showEnergyColumns">
                {{
                  useParitySystem
                    ? getParityHeaderText(parityRegistration.parity)
                    : i === 0
                      ? advice.parityAlternative2
                      : i === 1
                        ? advice.parityAlternative3
                        : i === 2
                          ? advice.parityAlternative4
                          : i === 3
                            ? advice.parityAlternative5
                            : i === 4
                              ? advice.parityAlternative6
                              : ''
                }}
              </th>
            </ng-container>
            <th class="align-left">{{ 'sows-feed-advice.table.product' | translate }}</th>
            <ng-container
              *ngFor="
                let parityRegistration of advice?.sowFeedAdviceLines[0].parityRegistrations;
                let i = index
              "
            >
              <th class="align-left">
                {{
                  useParitySystem
                    ? getParityHeaderText(parityRegistration.parity)
                    : i === 0
                      ? advice.parityAlternative2
                      : i === 1
                        ? advice.parityAlternative3
                        : i === 2
                          ? advice.parityAlternative4
                          : i === 3
                            ? advice.parityAlternative5
                            : i === 4
                              ? advice.parityAlternative6
                              : ''
                }}
              </th>
            </ng-container>
            <th class="align-left" *ngIf="advice.showDosatorColumns">
              {{ 'sows-feed-advice.table.feedingTimesPerDay2' | translate }}
            </th>
            <ng-container
              *ngFor="
                let parityRegistration of advice?.sowFeedAdviceLines[0].parityRegistrations;
                let i = index
              "
            >
              <th class="align-left" *ngIf="advice.showDosatorColumns">
                {{
                  useParitySystem
                    ? getParityHeaderText(parityRegistration.parity)
                    : i === 0
                      ? advice.parityAlternative2
                      : i === 1
                        ? advice.parityAlternative3
                        : i === 2
                          ? advice.parityAlternative4
                          : i === 3
                            ? advice.parityAlternative5
                            : i === 4
                              ? advice.parityAlternative6
                              : ''
                }}
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let line of advice?.sowFeedAdviceLines">
            <td>{{ line.dayFrom }}</td>
            <td>{{ line.dayTo }}</td>
            <ng-container *ngFor="let parityRegistration of line.parityRegistrations">
              <td *ngIf="showEnergyColumns" class="medium-column screen-only">
                {{ parityRegistration.ewKg | agrNumber: '1.2-2' }}
              </td>
            </ng-container>
            <td class="medium-column">{{ line.product.code }} - {{ line.product.name }}</td>
            <ng-container *ngFor="let parityRegistration of line.parityRegistrations">
              <td class="medium-column">{{ parityRegistration.feedKg | agrNumber: '1.1-1' }}</td>
            </ng-container>
            <td class="medium-column" *ngIf="advice.showDosatorColumns">
              {{ line.feedingTimesPerDay }}
            </td>
            <ng-container *ngFor="let parityRegistration of line.parityRegistrations">
              <td class="medium-column" *ngIf="advice.showDosatorColumns">
                {{ parityRegistration.dosatorPosition | agrNumber: '1.1-1' }}
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </ng-container>

    <div
      class="spacing--margin-top"
      [class.page-break-before]="advice?.sowFeedAdviceLines.length > 15"
    >
      <ng-container
        *ngIf="
          (printSetting === 'fullsize' && mode === 'view') ||
          ((mode === 'edit' || mode === 'create') && !hasErrors())
        "
      >
        <h3 class="spacing-top">
          {{ 'product-totals-table.title' | translate }}
        </h3>
        <h4>
          {{ 'product-totals-table.subtitle-feed' | translate }}
        </h4>
        <table class="summary-table" data-test="summary-table__feedKg">
          <thead>
            <tr>
              <th class="align-left product-column">
                {{ 'sows-feed-advice.table.product' | translate }}
              </th>
              <ng-container
                *ngFor="
                  let parityRegistration of sowFeedAdviceLines[0].parityRegistrations;
                  let i = index
                "
              >
                <th class="align-left">
                  {{
                    useParitySystem
                      ? getParityHeaderText(parityRegistration.parity)
                      : i === 0
                        ? advice.parityAlternative2
                        : i === 1
                          ? advice.parityAlternative3
                          : i === 2
                            ? advice.parityAlternative4
                            : i === 3
                              ? advice.parityAlternative5
                              : i === 4
                                ? advice.parityAlternative6
                                : ''
                  }}
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let productTotal of productTotals"
              [attr.data-test]="'summary-table__product_' + productTotal.productCode"
            >
              <td class="medium-column">
                {{ productTotal.productCode }} - {{ productTotal.productName }}
              </td>
              <ng-container *ngFor="let parityTotal of productTotal.parityTotals; let i = index">
                <td
                  class="medium-column"
                  [attr.data-test]="
                    'summary-table__feedKg_' + productTotal.productCode + '_' + (i + 1)
                  "
                >
                  {{ parityTotal.feedKg | agrNumber: '1.1-1' }}
                </td>
              </ng-container>
            </tr>
            <tr>
              <td class="align-right spacing--padding-right">
                <b>{{ 'total' | translate }}</b>
              </td>
              <ng-container
                *ngFor="let parityTotal of productTotals[0].parityTotals; let i = index"
              >
                <td>
                  <b>{{ getTotalFeed(i) | agrNumber: '1.1-1' }}</b>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>
    <div class="spacing--margin-top">
      <ng-container
        *ngIf="
          printSetting === 'fullsize' &&
          hasNettoPrices() &&
          (mode === 'view' || ((mode === 'edit' || mode === 'create') && !hasErrors()))
        "
      >
        <h4>
          {{ 'product-totals-table.subtitle-price' | translate }} ({{
            currency | agrCurrencySymbol
          }})
        </h4>
        <table class="summary-table" data-test="summary-table__unitNettoPrice">
          <thead>
            <tr>
              <th class="align-left product-column">
                {{ 'sows-feed-advice.table.product' | translate }}
              </th>
              <th *ngIf="mode === 'view'" class="align-left">
                {{ 'feed-advice-report.table.nettoPricePer100Kg' | translate }}
              </th>
              <ng-container
                *ngFor="
                  let parityRegistration of sowFeedAdviceLines[0].parityRegistrations;
                  let i = index
                "
              >
                <th class="align-left">
                  {{
                    useParitySystem
                      ? getParityHeaderText(parityRegistration.parity)
                      : i === 0
                        ? advice.parityAlternative2
                        : i === 1
                          ? advice.parityAlternative3
                          : i === 2
                            ? advice.parityAlternative4
                            : i === 3
                              ? advice.parityAlternative5
                              : i === 4
                                ? advice.parityAlternative6
                                : ''
                  }}
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let productTotal of productTotals">
              <td class="medium-column" data-test="summary-table__product">
                {{ productTotal.productCode }} - {{ productTotal.productName }}
              </td>
              <td *ngIf="mode === 'view'" class="medium-column" data-test="summary-table__product">
                {{ currency | agrCurrencySymbol }}
                {{ productTotal.unitNettoPrice | agrNumber: '1.2-2' }}
              </td>
              <ng-container *ngFor="let parityTotal of productTotal.parityTotals; let i = index">
                <td
                  class="medium-column"
                  [attr.data-test]="
                    'summary-table__unitNettoPrice_' + productTotal.productCode + '_' + (i + 1)
                  "
                >
                  {{
                    getTotalNettoPrice(parityTotal.feedKg, productTotal.unitNettoPrice)
                      | agrNumber: '1.2-2'
                  }}
                </td>
              </ng-container>
            </tr>
            <tr>
              <td *ngIf="mode === 'view'"></td>
              <td class="align-right spacing--padding-right">
                <b>{{ 'total' | translate }}</b>
              </td>
              <ng-container
                *ngFor="let parityTotal of productTotals[0].parityTotals; let i = index"
              >
                <td>
                  <b>{{ getSumTotalNettoPrice(i) | agrNumber: '1.2-2' }}</b>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </ng-container>
    </div>

    <div class="spacing--margin-top">
      <agr-notification-empty
        [isEmpty]="mode === 'edit' && hasErrors()"
        [emptyTitle]="'product-totals-table.empty-title' | translate"
        [emptyDescription]="'product-totals-table.empty-description' | translate"
        emptyImage="assets/images/pigs_001.jpg"
      >
      </agr-notification-empty>
    </div>
    <app-sows-feed-advice-graph
      *ngIf="
        (printSetting === 'fullsize' && mode === 'view') ||
        ((mode === 'edit' || mode === 'create') && !hasErrors())
      "
      [advice]="advice"
      [lines]="sowFeedAdviceLines"
      [parityCategory]="this.parityCategory"
    ></app-sows-feed-advice-graph>
  </div>
</agr-page-detail>
